import 'slick-carousel';
import mobileNavigation from '../mobileNavigation';
import articles from '../articles';
import projects from '../projects';
import socialSharer from '../socialSharer';
import slickSliders from '../slickSliders';
import contactForm from '../contactForm';
import googleMap from '../googleMap';
import backToTop from '../backToTop';

export default {
  init() {
    // JavaScript to be fired on all pages
    new mobileNavigation();
    new articles();
    new projects();
    new socialSharer();
    new slickSliders();
    new contactForm();
    new googleMap();
    new backToTop();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js